import { render, staticRenderFns } from "./EditDialogEventMainContainer.vue?vue&type=template&id=ba158fb2&scoped=true"
import script from "./EditDialogEventMainContainer.vue?vue&type=script&lang=js"
export * from "./EditDialogEventMainContainer.vue?vue&type=script&lang=js"
import style0 from "./EditDialogEventMainContainer.vue?vue&type=style&index=0&id=ba158fb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba158fb2",
  null
  
)

export default component.exports